import $ from "jquery";

$.fn.injectForm = function injectForm(html) {
  return this.html(html).promise().done(function injectFormDone() {
    $('[autofocus]').focus();
  });
};
